import gql from "graphql-tag";

const DischargeProps = gql`
    fragment DischargeProps on Discharge {
        id
        comment
        documents {
            comment
            date
            title
        }
        endOfLife
        homeForLife
        external {
            address1
            address2
            address3
            city
            country
            mobile
            postcode
        }
        locationType
        service
        securityLevel
        type
        created_at
        summary {
            title
            date
            comment
        }
        checklistDocument
        date
        confirm {
            status
            date
        }
        status
    }
`;

export const GET_PATIENT_DISCHARGE = gql`
    query GetPatientDischarge($patient: ID!) {
        GetPatientDischarge(patient: $patient) {
            doc {
                ...DischargeProps
            }
        }
    }
    ${DischargeProps}
`;

export const NEW_PATIENT_DISCHARGE = gql`
    mutation NewPatientDischarge($model: PatientDischargeInput!, $confirmed: Boolean!) {
        NewPatientDischarge(model: $model, confirmed: $confirmed) {
            message
            doc {
                ...DischargeProps
            }
        }
    }
    ${DischargeProps}
`;

export const CONFIRM_DISCHARGE = gql`
    mutation ConfirmDischarge($id: ID!) {
        ConfirmPatientDischarge(id: $id) {
            message
        }
    }
`;
